module.exports = __webpack_public_path__ + "static/media/header.39e32e6a.png";